import ClicColInterno from '../clicGridLayout/ClicColInternoModel'


import ClicMetabaseChartDocs from './ClicMetabaseChartDocs';

export default {
    ClicMetabaseChart : {
        config      : {icon:"md-stackedbarchart-round", documentation: ClicMetabaseChartDocs.documentation },
        component   : {type: 'string', component: { name : '' }, disabled:true},
        id          : {type: 'string', component: { name : '' } },

        props : {

            indicador               : { type: 'string',      default: undefined,        component: { name : 'input' } },
            // Formato antigo (id do dashboard): continua aceito, mas fica fora do editor; as telas usam o indicador
            metabaseDashboardId     : { type: 'string',      default: undefined,        component: { name : 'input' }, visible: false },
            theme                   : { type: 'string',      default: "transparent",    component: { name : 'input' } },
            bordered                : { type: 'boolean',     default: false,            component: { name : 'switch' } },
            titled                  : { type: 'boolean',     default: true,             component: { name : 'switch' } },

            ...ClicColInterno,

        },
        events : {

        }
    }
}
